import React from 'react';
import CharterType from '../Form/CharterType';
import FormInput from '../Form/FormInput';
import BooleanInput from '../Form/BooleanInput';
import { useHistory } from 'react-router-dom';
import { Container, Row, Col, Input, FormGroup } from 'reactstrap';
import StringSelector from '../Form/StringSelector';
import { useAuth } from '../../Services/AuthContext';
import SupplierLocationSelector from '../Form/SupplierLocationSelector';
import { useEdit } from '../../Services/EditContext';
import { FormLabel } from '../Form/FormLabel';
import { useFormikContext } from 'formik';
import { ISupplier } from '../../Models/ISupplier';
import { Button } from 'react-bootstrap';
import SecondaryEmails from '../EntityList/SecondaryEmails';

const SupplierFormInput = FormInput as (props:
    { id: keyof ISupplier, label: string, readOnly?: boolean, type?: string }) => JSX.Element;
const SupplierBooleanInput = BooleanInput as (props: { id: keyof ISupplier, label: string }) => JSX.Element;

interface props {
    invite?: boolean, route?: string
}

const Supplier = ({ invite, route = "" }: props) => {
    const [user] = useAuth();
    const [edit] = useEdit();
    const { location, push } = useHistory();
    const { values, setFieldValue } = useFormikContext() as unknown as
        { values: ISupplier, setFieldValue: (field: keyof ISupplier, value: unknown) => void };
    const { role } = user;
    const isAdmin = role === 'Admin';

    const handleChangeEmailLocationFilter = (e) => {
        setFieldValue('locationFilterEnabled', e.target.checked);
    }
    const handleChangePassengerRange = (e) => {
        setFieldValue('passengerRangeFilterEnabled', e.target.checked);
    }
    return <React.Fragment>
        <Container>
            <Row>
                <Col>
                    <Row>
                        <Col>
                            <SupplierFormInput id='companyName' label='Company Name' />
                        </Col>
                        <Col>
                            <SupplierFormInput id='companyAddress' label='Company Address' />
                        </Col>

                    </Row>
                    <Row>
                        <Col>
                            <SupplierFormInput id='firstName' label='First Name' />
                        </Col>
                        <Col>
                            <SupplierFormInput id='lastName' label='Last Name' />
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <SupplierFormInput id='companyPhone' label='Company Phone' type='phone' />
                        </Col>
                        <Col>
                            <SupplierFormInput readOnly={!invite} id='email' label='Email' type='email' />
                            <Button onClick={() => {
                                push(`${route}/${values.id}/Detail/supplierSecondaryEmails`)
                            }} >Secondary Emails</Button>
                        </Col>
                    </Row>
                    {isAdmin && <Row>
                        <Col>
                            <SupplierBooleanInput id='preferred' label='Preferred' />
                        </Col>
                        <Col>
                            <StringSelector id='clientTypes' label="Client Type" stringType list={['Generic', 'Generic, QGov']} />
                        </Col>
                        <Col>
                            <StringSelector id='complianceTypes' hideAllButton label="Compliances" isMulti stringType list={
                                ['IFR Operations', 'Safety Management System', 'VFR Operations', 'Maintenance Compliance']} />

                        </Col>

                    </Row>}
                </Col>
            </Row>
            <Row>
                <Col>
                    <Row>
                        <SupplierBooleanInput id='doNotSendBidConfirmation' label='Do Not Send Me Bid Confirmation Emails' />
                    </Row>
                    <Row>
                        <SupplierBooleanInput id='notifyOfManifestChanges' label='Notify Me Of Manifest Changes' />
                    </Row>
                    <Row>
                        <CharterType id='charterTypes' label='Charter Types' supplier />
                    </Row>
                    <Row>
                        <Col>
                            <Container>

                                {edit ? <FormGroup style={{ marginLeft: '7px' }}><FormLabel check htmlFor='locationFilterEnabled'>
                                    <Input type='checkbox' id='locationFilterEnabled'
                                        name='locationFilterEnabled' placeholder="Supplier Location"
                                        checked={values.locationFilterEnabled} onChange={handleChangeEmailLocationFilter} />Enable filtering Email notifications by location
                                </FormLabel></FormGroup> : <FormLabel>
                                    Filtering Email notifications by location {values.locationFilterEnabled ? ' Enabled' : ' Disabled'}
                                </FormLabel>}
                            </Container>
                        </Col>
                    </Row>
                    {values.locationFilterEnabled ? <Row>
                        <Col>
                            <SupplierLocationSelector isMulti id='filterLocation' label='Service  Regions' />
                        </Col>
                    </Row> : null}
                    <Row>
                        <Col>
                            <Container>
                                {edit ? <FormGroup style={{ marginLeft: '7px' }}> <FormLabel check htmlFor='passengerRangeFilterEnabled'>
                                    <Input type='checkbox' id='passengerRangeFilterEnabled'
                                        name='passengerRangeFilterEnabled' placeholder="Passenger Range"
                                        checked={values.passengerRangeFilterEnabled} onChange={handleChangePassengerRange} />Enable filtering Email notifications by passenger numbers
                                </FormLabel> </FormGroup> : <FormLabel>
                                    Filtering Email notifications by Passenger Numbers {values.passengerRangeFilterEnabled ? ' Enabled' : ' Disabled'}
                                </FormLabel>
                                }
                            </Container>
                        </Col>
                    </Row>
                    {values.passengerRangeFilterEnabled ? <Row>
                        <Col>
                            <SupplierFormInput id='minPassengers' label='Min Passengers' />
                        </Col>
                        <Col>
                            <SupplierFormInput id='maxPassengers' label='Max Passengers' />
                        </Col>
                    </Row> : null}
                </Col>
            </Row>
        </Container>
        <SecondaryEmails supplier={values} onClose={() => { push(`${route}/${values.id}/Detail`); }} open={location.pathname.endsWith('supplierSecondaryEmails')} />
    </React.Fragment>
};
export default Supplier;




